import { render, staticRenderFns } from "./SodWarningDialog.vue?vue&type=template&id=5d808da0"
import script from "./SodWarningDialog.vue?vue&type=script&lang=js"
export * from "./SodWarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports